export const OPTIONS = [
    { value: 1, name: "RUB" },
    { value: 2, name: "USD" },
    { value: 3, name: "CNY" },
]
